import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useCallback, useState } from "react";
import { CreateEmailsModal } from ".";

type CreateButtonProps = {
  isLoading: boolean;
  reloadData: () => void;
};

export const CreateButton = ({ isLoading, reloadData }: CreateButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openModal = useCallback((): void => setIsModalOpen(true), []);

  return (
    <>
      <Button icon={<PlusOutlined />} shape="round" type="primary" disabled={isLoading} onClick={openModal}>
        Daily Emails
      </Button>

      {isModalOpen && (
        <CreateEmailsModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} reloadData={reloadData} />
      )}
    </>
  );
};
